module.exports = __webpack_public_path__ + "static/media/game_detail_result.57750910.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_detail_result.png
// module id = 498
// module chunks = 38